export default __webpack_public_path__ + "static/media/step8-3.57bfe661.png";